import styled from 'styled-components'

export const Header = styled.h2`
  margin-bottom: 60px;
  padding-bottom: 30px;
  height: 35vh;
  
  display: flex;
  justify-content: center;
  align-items: flex-end;
  
  font-size: 2rem;
  font-weight: 500;
  color: #fff;
  
  background-color: #000;
`